import { useMemo } from "react";

export const useCategoryMap = (categories) => {
  return useMemo(() => {
    const map = {};

    const traverse = (nodes) => {
      nodes.forEach((n) => {
        map[n.slug] = n;
        if (n.children) traverse(n.children);
      });
    };

    traverse(categories || []);
    return map;
  }, [categories]);
};

export const buildPath = (slugs, categoryMap) => {
  const path = [];

  slugs.forEach((slug) => {
    if (!slug) return;
    const node = categoryMap[slug];
    if (node) path.push({ slug, label: node.name });
  });

  return path;
};

export const extractProductsFromTree = (node, categories = []) => {
  const newCategories = categories.concat([
    { name: node.name, isFamily: node.isFamily, slug: node.slug },
  ]);
  let prods = node.products.map((p) => ({ ...p, categories: [newCategories] }));
  if (node.children) {
    node.children.forEach((ch) => {
      prods = prods.concat(extractProductsFromTree(ch, newCategories));
    });
  }
  return prods;
};
